export function BeforeAfter() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Website Before vs After
          </h2>
          <div className="w-24 h-1 bg-teal-500 mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See the transformation from typical website problems to a high-performing digital asset
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Before */}
          <div className="relative">
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-red-500 rounded-2xl flex items-center justify-center shadow-lg z-10">
              <span className="text-white font-bold text-lg">Before</span>
            </div>
            <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl p-8 pt-16 border-2 border-gray-300">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Typical Website Problems</h3>
              <div className="space-y-4">
                {[
                  'Outdated design that looks unprofessional',
                  'Little to no search visibility on Google',
                  'Weak lead generation and conversion',
                  'Poor mobile usability and slow loading',
                  'No optimization for AI or voice search',
                  'Invisible on Google Maps'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-red-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-close-line text-white text-sm"></i>
                    </div>
                    <p className="text-gray-700">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* After */}
          <div className="relative">
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-teal-500 rounded-2xl flex items-center justify-center shadow-lg z-10">
              <span className="text-white font-bold text-lg">After</span>
            </div>
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl p-8 pt-16 border-2 border-teal-500">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Digital Age Advantages</h3>
              <div className="space-y-4">
                {[
                  'Modern, professional design that builds trust',
                  'Structured for maximum search visibility',
                  'Optimized lead generation flow',
                  'Fast, mobile-first performance',
                  'AI and voice search ready',
                  'Google Maps optimized for local discovery'
                ].map((item, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <p className="text-gray-700 font-medium">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-block bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl p-8 text-white shadow-xl">
            <p className="text-2xl font-bold mb-2">The Difference Is Clear</p>
            <p className="text-lg">A website built to work as hard as you do</p>
          </div>
        </div>
      </div>
    </section>
  );
}